import React from 'react';
import { Link } from 'react-router-dom'; // استيراد Link لعناصر التنقل
import '../assets/css/CareerHeadingSection.css';

function CareerHeadingSection() {
  return (
    <section id="career-heading" className="career-heading">
      <div className="career-heading-container">
   
        <h1 className="career-main-title">انضم إلى فريقنا</h1>
        <p className="career-subtitle">
          نحن نبحث دائمًا عن المواهب الشغوفة لإحداث فرق. اكتشف فرصك معنا.
        </p>

      </div>
    </section>
  );
}

export default CareerHeadingSection;